import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbAuthModule } from '@nebular/auth';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { NbToastrModule } from '@nebular/theme';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { Api } from './services/api.service';
import { AuthenticationService } from './services/authentication.api.service';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { LaddaService } from './services/ladda.service';
import { BrowserStorageService } from './store/localStorage.service';
import { RouterService } from './utils/router.service';
import { RoleService } from './services/role.service';
import { AccessControl } from './models/access-control';
import { DEAccessCheckerService } from './services/access-checker.service';
import { ModifyResponseInterceptor } from './interceptor/modify-response.interceptor';

export const NB_CORE_PROVIDERS = [
  NbSecurityModule.forRoot({
    accessControl: AccessControl.accessRight,
  }).providers,
  {
    provide: NbRoleProvider,
    useClass: RoleService,
  },
];

const services = [
  Api,
  AuthenticationService,
  BrowserStorageService,
  RouterService,
  RoleService,
  DEAccessCheckerService,
];

@NgModule({
  exports: [NbAuthModule],
  declarations: [], imports: [CommonModule, NbToastrModule], providers: [
    ...services,
    LaddaService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ModifyResponseInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
